import React from "react";
import PropTypes from "prop-types";

export default function QuestionCircle(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.8955 13.9536C16.529 13.4567 16.9092 13.005 16.9092 12.207C16.9092 11.2735 16.2439 10.6261 15.1193 10.6261C13.8997 10.6261 13.0285 11.3187 13.0444 12.9749H11.0011C10.9536 10.6261 12.49 9 15.1352 9C17.8596 9 19 10.4605 19 12.1016C19 13.5471 18.3031 14.2999 17.3369 15.0678L16.434 15.7754C15.9905 16.1217 15.8479 16.2572 15.8479 16.7842V17.4617H13.9789V16.4981C13.9789 15.5345 14.2006 15.3087 15.0401 14.6311L15.8955 13.9536Z"
        fill="#B9C3DB"
      />
      <path d="M16.1331 18.8921V21H13.6779V18.8921H16.1331Z" fill="#B9C3DB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15ZM28 15C28 22.1797 22.1797 28 15 28C7.8203 28 2 22.1797 2 15C2 7.8203 7.8203 2 15 2C22.1797 2 28 7.8203 28 15Z"
        fill="#B9C3DB"
      />
    </svg>
  );
}

QuestionCircle.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

QuestionCircle.defaultProps = {
  className: "",
  width: 30,
  height: 30
};
